import { GenericUser, UserTypes } from "../../_models";
import { UserPermissions } from "../../_models/user/user-permissions";
import { UserPermissionType } from "../../_models/user/user-permission-type";

const isAdminUserMeshutaf = (user: GenericUser) =>
  user.type && user.type === UserTypes.TYPE_MESHUTAF;

const isAdminUserTalpanMobile = (user: GenericUser) =>
  user.type && user.type >= UserTypes.TYPE_TALPAN_WITH_MOBILE;

const isAdminUserRakazKenOrUp = (user: GenericUser) =>
  user.type && user.type >= UserTypes.TYPE_RAKAZ_KEN;

const isAdminUserRakazMaagalOrUp = (user: GenericUser) =>
  user.type && user.type >= UserTypes.TYPE_RAKAZ_MAAGAL;

const isAdminUserAllowedMihlol = (user: GenericUser) =>
  user.type && user.type >= UserTypes.TYPE_RAKAZ_KEN;

const isGizbarMaagalOrUp = (user: GenericUser) =>
  isAdminUserRakazMaagalOrUp(user) && user.hasRefundCode;

const isRakazMahozOrUp = (user: GenericUser) =>
  user.type && user.type >= UserTypes.TYPE_RAKAZ_MAHOZ;

const isSuperAdmin = (user: GenericUser) =>
  user.type && user.type === UserTypes.TYPE_SUPER_ADMIN;

export const CalculateUSerPermissionFromUser = (user: GenericUser) => {
  const permissions: UserPermissions = {
    allowedMihlol: false,
    isMeshutaf: false,
    rakazKenOrUp: false,
    rakazMaagalOrUp: false,
    talpanMobile: false,
    gizbarMaagalOrUp: false,
    rakazMahozOrUp: false,
    isSuperAdmin: false,
    userType:
      user && user.role === "ADMIN"
        ? UserPermissionType.RakazUser
        : UserPermissionType.ParentUser,
  };
  if (permissions.userType === UserPermissionType.RakazUser) {
    permissions.rakazMahozOrUp = isRakazMahozOrUp(user);
    permissions.allowedMihlol = isAdminUserAllowedMihlol(user);
    permissions.isMeshutaf = isAdminUserMeshutaf(user);
    permissions.rakazKenOrUp = isAdminUserRakazKenOrUp(user);
    permissions.rakazMaagalOrUp = isAdminUserRakazMaagalOrUp(user);
    permissions.talpanMobile = isAdminUserTalpanMobile(user);
    permissions.gizbarMaagalOrUp = isGizbarMaagalOrUp(user);
    permissions.isSuperAdmin = isSuperAdmin(user);
  }
  return Object.freeze(permissions);
};



// WEBPACK FOOTER //
// ./src/app/_services/SessionManager/session-manager.user-premission.ts